// import directly from the the module to avoid circular dependencies
import { rateLimitMutatorRef } from "../Reference/rateLimitMutatorRef.js";
import { throttleAnimationFrame } from "./throttleAnimationFrame.js";
import { throttleTimeout } from "./throttleTimeout.js";
/**
 * Leading-edge throttle function that calls the function
 * at most once per the specified time and guarantees the last
 * call will be applied.
 *
 * @public
 */
export function throttle(fn, wait) {
    if (typeof wait === "number") {
        return throttleTimeout(fn, wait);
    }
    if (wait === throttle.Wait.AnimationFrame) {
        return throttleAnimationFrame(fn);
    }
    throw new Error(`Invalid throttle type: ${wait}`);
}
(function (throttle) {
    /**
     * @public
     */
    let Wait;
    (function (Wait) {
        Wait["AnimationFrame"] = "animationFrame";
    })(Wait = throttle.Wait || (throttle.Wait = {}));
    /**
     * Leading-edge throttle function that updates the reference
     * at most once per the specified time and guarantees the last
     * update will be applied.
     *
     * @public
     */
    function reference(origin$, wait) {
        return rateLimitMutatorRef(origin$, (fn) => throttle(fn, wait));
    }
    throttle.reference = reference;
})(throttle || (throttle = {}));
